import { Landmark } from 'lucide-react';
import { echeqSaldoDetalle, saldoEnDespacho, useSaldosEcheq } from '@/shared/components/EcheqSaldoTag';

/**
 * Aviso de E-cheqs en Pagos (regla en server/src/lib/echeqs.ts): con el 100%
 * de los pagos cargado la venta pasa a despacho aunque los E-cheqs no estén
 * acreditados; si lo cobrado no llega al % del total, el despacho queda
 * retenido; si llega, se despacha pero no se cierra hasta estar paga.
 */
export function EcheqDespachoAviso({ ventaId, status }: { ventaId: string; status: string | null }) {
  const saldos = useSaldosEcheq();
  const saldo = saldos.get(ventaId);
  if (!saldo || !status) return null;
  const enDespacho = saldoEnDespacho(saldos, ventaId, status);
  if (enDespacho) {
    return (
      <Aviso tono={saldo.retenido ? 'rose' : 'orange'} titulo={saldo.retenido ? 'Despacho retenido: faltan cobrar E-cheqs' : 'Pago parcial con E-cheqs'}>
        {echeqSaldoDetalle(saldo)}
      </Aviso>
    );
  }
  return (
    <Aviso tono="amber" titulo="Venta con E-cheqs">
      Con el 100% de los pagos cargado (los demás, confirmados) pasa a despacho aunque los E-cheqs no
      estén acreditados. Se puede despachar con el {saldo.pctRequerido}% de la venta cobrado (hoy{' '}
      {saldo.pctCobrado}%).
    </Aviso>
  );
}

const TONOS = {
  amber: 'border-amber-300 bg-amber-50 text-amber-900',
  rose: 'border-rose-300 bg-rose-50 text-rose-900',
  orange: 'border-orange-300 bg-orange-50 text-orange-900',
};

function Aviso({ tono, titulo, children }: { tono: keyof typeof TONOS; titulo: string; children: React.ReactNode }) {
  return (
    <div className={`flex shrink-0 items-start gap-2 rounded-lg border px-3 py-2 text-sm ${TONOS[tono]}`}>
      <Landmark className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
      <div className="min-w-0">
        <div className="font-medium">{titulo}</div>
        <div className="text-xs opacity-90">{children}</div>
      </div>
    </div>
  );
}

